module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "order-xs2": "",
      "order-sm1": ""
    }
  }, [_c('v-list', {
    staticClass: "pb-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search",
      "prepend-icon": "search",
      "clearable": "",
      "solo": ""
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('v-subheader', [_c('help-popover', [_vm._v(_vm._s(_vm.$t('help.text')))]), _vm._v("\n      " + _vm._s(_vm.$t('help.title')) + "\n    ")], 1), _vm._v(" "), _vm._l((_vm.filteredAppointments), function(item) {
    return [(!item.invoiceable) ? _c('v-list-tile', {
      key: item.id
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "value": item.id
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title || item.full_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          " + _vm._s(_vm.dateformat(item.start_time)) + "\n        ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-tooltip', {
      attrs: {
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "to": ("/appointments/" + (item.id)),
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('span', [_vm._v("Go to appointment")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      key: ("d-" + (item.id))
    })]
  })], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "appear": "",
      "mode": "in-out"
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": "",
      "order-xs1": "",
      "order-sm2": ""
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "mode": "out-in",
      "name": "fade"
    }
  }, [(_vm.selected && _vm.selected.length > 0) ? _c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-chip', {
    attrs: {
      "color": "primary",
      "dark": "",
      "text-color": "white"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selected.length) + " selected appointments\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-expansion-panel', {
    staticClass: "elevation-4",
    model: {
      value: (_vm.exandr),
      callback: function($$v) {
        _vm.exandr = $$v
      },
      expression: "exandr"
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Invoice details")]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "value": _vm.showSuccessNotification,
      "color": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n                    Selected appointments successfully updated\n                  ")]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote px-0"
  }, [_vm._v("\n                    Set the invoice title and description for " + _vm._s(_vm.selected.length) + " appointments\n                  ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Invoice title",
      "hint": "The line item title we will show on invoices"
    },
    model: {
      value: (_vm.appointmentData.invoice_title),
      callback: function($$v) {
        _vm.$set(_vm.appointmentData, "invoice_title", $$v)
      },
      expression: "appointmentData.invoice_title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Invoice description",
      "hint": "An optional extra description to show on the invoice"
    },
    model: {
      value: (_vm.appointmentData.invoice_description),
      callback: function($$v) {
        _vm.$set(_vm.appointmentData, "invoice_description", $$v)
      },
      expression: "appointmentData.invoice_description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.invoiceDataRequest.loading,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Add Codes")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "grey lighten-4"
  }, [_c('v-card-text', [_c('bulk-add-codes', {
    attrs: {
      "appointment-ids": _vm.selected
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.selected && _vm.selected.length > 0) ? _c('v-card', {
    staticClass: "my-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "loading": _vm.markInvoiceableRequest.loading
    },
    on: {
      "click": _vm.markInvoiceable
    }
  }, [_c('v-icon', {
    staticClass: "mx-2"
  }, [_vm._v("check_circle_outline")]), _vm._v("\n              Mark " + _vm._s(_vm.selected.length) + " appointments as invoiceable\n            ")], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('vuex-snackbar', {
    attrs: {
      "req-id": _vm.bulkReqId,
      "success-message": "Appointments marked as invoiceable",
      "error-message": "Unable to update invoices. Please try again"
    }
  }), _vm._v(" "), _c('vuex-snackbar', {
    attrs: {
      "req-id": _vm.bulkReqIdData,
      "success-message": "Appointments updated",
      "error-message": "Unable to update invoices. Please try again"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7d19e64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/AppointmentsTodo.vue
// module id = 1549
// module chunks = 9